module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    attrs: {
      "items": _vm.options,
      "item-text": "Name",
      "item-value": "value",
      "clearable": !_vm.disabled,
      "outlined": !_vm.disabled,
      "filled": _vm.disabled,
      "dense": "",
      "hide-details": "true",
      "label": "Network",
      "id": "networkSelect",
      "disabled": _vm.disabled
    },
    on: {
      "input": function (val) { return _vm.$emit('update', val); }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aada7d5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/components/MarketingNetworkSelect.vue
// module id = 1805
// module chunks = 0